"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivitySparklineSection = void 0;
var react_1 = __importDefault(require("react"));
/**
 * Compact 12-week activity bar chart that signals whether mentions
 * of this element are rising or fading. Hidden when the catalogue
 * has no recent activity at all (sum of counts === 0).
 */
exports.ActivitySparklineSection = function (_a) {
    var heatmap = _a.heatmap;
    if (!heatmap || heatmap.length === 0)
        return null;
    var total = heatmap.reduce(function (acc, p) { return acc + p.count; }, 0);
    if (total === 0)
        return null;
    var max = Math.max.apply(Math, heatmap.map(function (p) { return p.count; }));
    var peakHeightPx = 36;
    return (react_1.default.createElement("section", { className: "ws-entity-popup-section", "data-section-id": "activity" },
        react_1.default.createElement("h4", { className: "ws-entity-popup-section-title" },
            "Activity",
            ' ',
            react_1.default.createElement("span", { style: { color: '#6b7280', fontWeight: 400 } },
                "\u00B7 last ",
                heatmap.length,
                " weeks \u00B7 ",
                total,
                " mentions")),
        react_1.default.createElement("div", { style: {
                display: 'flex',
                alignItems: 'flex-end',
                gap: 3,
                height: peakHeightPx + 4,
                padding: '4px 0',
            } }, heatmap.map(function (p) {
            var heightPx = max > 0 ? Math.max(2, Math.round((p.count / max) * peakHeightPx)) : 2;
            return (react_1.default.createElement("div", { key: p.weekStart, title: p.weekStart + ": " + p.count, style: {
                    width: 8,
                    height: heightPx,
                    background: p.count === 0 ? '#e5e7eb' : '#3b82f6',
                    borderRadius: 2,
                } }));
        }))));
};
